import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TopHeaderService } from 'src/app/core/services/top-header/top-header.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-score-area',
  templateUrl: './score-area.component.html',
  styleUrls: ['./score-area.component.scss'],
})
/**
 * Shows information about user score and other related information
 */
export class ScoreAreaComponent implements OnInit, OnDestroy {
  labels = {
    for: 'for',
    vip: 'vip',
    level: 'level',
    rewards: 'rewards',
    showMore: 'show-more',
    series: 'series',
    totalPointsFor: 'total-points-for',
  };

  profilePicture = '';
  loading = false;
  private subsink = new Subscription();

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    public readonly topHeaderService: TopHeaderService,
    private router: Router
  ) {
    this.translationService.translateObject(this.labels);
  }

  /**
   * on init
   */
  ngOnInit() {
    if (
      this.topHeaderService.business == null ||
      this.topHeaderService.pointSummary == null
    ) {
      this.loading = true;
    }
    this.topHeaderService.fetchTopHeaderInfo().finally(() => {
      this.loading = false;
    });
  }

  /**
   * clean up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Redirect to the point balance
   */
  navigateToPointsDetail() {
    this.router.navigate(['/point-balance-list']);
  }
}
